<template>
  <div class="d-flex mb-3">
    <b>
      <i class="fa fa-location-dot text-black fs-6" />
    </b>
    <span>
      <b class="text-black fs-6">
        {{ title }}
      </b>
      <br />
      <span class="subtitle">
        {{ t("PAYJOY_CARD_VIEWS.ADDRESS_FORM_SUBTITLE") }}
      </span>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

export default defineComponent({
  name: "ShippingAddressHeader",
  props: {
    customTitle: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const title = props.customTitle
      ? props.customTitle
      : t("PAYJOY_CARD_VIEWS.ADDRESS_FORM_TITLE");
    return { t, title };
  },
});
</script>

<style lang="scss" scoped>
.subtitle {
  font-size: 13px;
}
</style>
